import { lazy, Suspense, type ReactNode } from "react";

const ChakraProviderLazy = lazy(() =>
  import("@/components/chakra/ChakraProvider").then((m) => ({
    default: m.ChakraProvider,
  })),
);

interface ChakraBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function ChakraBoundary({ children, fallback = null }: ChakraBoundaryProps) {
  return (
    <Suspense fallback={fallback}>
      <ChakraProviderLazy>{children}</ChakraProviderLazy>
    </Suspense>
  );
}
